import { makeStyles } from '@material-ui/styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default makeStyles((theme: any) => ({
  container: {
    padding: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
  mainContent: {
    maxWidth: '1300px',
    display: 'flex',
    columnGap: '16px',
    '& > div:first-child': {
      width: '696px',
    },
    '& > div:last-child': {
      width: '300px',
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  editor: {
    backgroundColor: '#FFF',
    minWidth: 440,
  },
  textInput: {
    fontSize: 12,
    marginTop: 15,
    marginBottom: 10,
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    '& legend': {
      fontSize: '0.90em',
    },
  },
  autoSaveLoadingContainer: {
    backgroundColor: 'white',
    borderRadius: 10,
    marginBottom: 10,
    width: 'fit-content',
  },
  autosaveLoading: {
    textAlign: 'left',
    fontSize: 14,
  },
  textTitleContent: {
    marginTop: '20px',
    textAlign: 'center',
  },
  chip: {
    marginTop: 10,
    backgroundColor: 'grey',
  },
  buttonAnalysis: {
    height: 36,
    width: 36,
    minWidth: 36,
    marginLeft: 8,
  },
  flatPaper: {
    marginTop: 10,
    padding: '9px !important',
    backgroundColor: 'white',
    borderRadius: 6,
  },
  flatPaperText: {
    fontSize: 15,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  articleTypeText: {
    marginLeft: 'auto',
    fontSize: 13.5,
  },
  linkToSheets: {
    display: 'flex',
    alignItems: 'center',
    color: 'grey',
    fontSize: '14px',
    fontWeight: 'bold',
    width: 'fit-content',
    '& span': {
      marginTop: '2px',
    },
  },
}));
